import './ShowDescription.scss'

const ShowDescription = null
export default ShowDescription
